import type { SnapshotFrom } from "xstate";

import { E_OnboardingV2State } from "./onboarding-v2-machine";
import type { onboardingV2Machine } from "./onboarding-v2-machine";

export type T_OnboardingV2ProgressErrorStage = "source" | "ingest_choice";

export type T_OnboardingV2ConversationProjection = {
  progressError: string | null;
  progressErrorCode: string | null;
  progressErrorStage: T_OnboardingV2ProgressErrorStage | null;
  showDetailOptions: boolean;
  showDetailPromptStreaming: boolean;
  showGreeting: boolean;
  showGreetingStreaming: boolean;
  showHandoffTyping: boolean;
  showIntroTyping: boolean;
  showOtherSourceInput: boolean;
  showSecondQuestion: boolean;
  showSourceOptions: boolean;
  showSourceSaving: boolean;
  showSourcePrompt: boolean;
  showSourcePromptStreaming: boolean;
};

export function projectOnboardingV2Conversation(
  snapshot: SnapshotFrom<typeof onboardingV2Machine>,
): T_OnboardingV2ConversationProjection {
  const sourceSaveFailed = snapshot.matches(
    E_OnboardingV2State.SourceSaveFailed,
  );
  const detailSaveFailed = snapshot.matches(
    E_OnboardingV2State.DetailSaveFailed,
  );
  const showGreeting = !snapshot.matches(E_OnboardingV2State.Welcome);
  const showSourcePrompt =
    showGreeting && !snapshot.matches(E_OnboardingV2State.Greeting);
  const showSecondQuestion =
    snapshot.matches(E_OnboardingV2State.DetailPrompt) ||
    snapshot.matches(E_OnboardingV2State.Detail) ||
    snapshot.matches(E_OnboardingV2State.SavingDetail) ||
    detailSaveFailed ||
    snapshot.matches(E_OnboardingV2State.Handoff);

  return {
    progressError: snapshot.context.progressError,
    progressErrorCode: snapshot.context.progressErrorCode,
    progressErrorStage: sourceSaveFailed
      ? "source"
      : detailSaveFailed
        ? "ingest_choice"
        : null,
    showDetailOptions: snapshot.matches(E_OnboardingV2State.Detail),
    showDetailPromptStreaming: snapshot.matches(
      E_OnboardingV2State.DetailPrompt,
    ),
    showGreeting,
    showGreetingStreaming: snapshot.matches(E_OnboardingV2State.Greeting),
    showHandoffTyping:
      snapshot.matches(E_OnboardingV2State.SavingDetail) ||
      snapshot.matches(E_OnboardingV2State.Handoff),
    showIntroTyping:
      snapshot.matches(E_OnboardingV2State.Welcome) ||
      snapshot.matches(E_OnboardingV2State.Typing),
    showOtherSourceInput: snapshot.matches(E_OnboardingV2State.SourceOther),
    showSecondQuestion,
    showSourceOptions: snapshot.matches(E_OnboardingV2State.Source),
    showSourceSaving: snapshot.matches(E_OnboardingV2State.SavingSource),
    showSourcePrompt,
    showSourcePromptStreaming: snapshot.matches(E_OnboardingV2State.Prompt),
  };
}
